const staffMessages = {
  'staff.title': 'ユーザー管理',
  'staff.title.button.sync.authority': '権限同期',
  'staff.title.sync.authority.success': '同期が完了しました。',
  'staff.title.sync.authority.failure.403': '操作権限がありません。',
  'staff.select.default': '企業で絞り込み(デフォルト:全企業)',
  'staff.detailDialog.title': 'ユーザー詳細',
  'staff.editDialog.title': 'ユーザー編集',
  'staff.createDialog.title': 'ユーザー追加',
  'staff.dialog.item.lastUpdateDate': '最終更新日時',
  'staff.dialog.cancelConfirm.message1': 'ユーザー編集をキャンセルします。',
  'staff.dialog.cancelConfirm.message2':
    'ユーザー編集をキャンセルすると編集内容は破棄されますがよろしいですか。',
  'staff.dialog.deleteConfirm.title': 'ユーザー削除',
  'staff.dialog.deleteConfirm.message1': 'を削除します。',
  'staff.dialog.deleteConfirm.message2':
    '※ユーザーを削除すると紐づくデータにも影響が及びます。',
  'staff.createDialog.input.userName.placeholder': 'アカウント名',
  'staff.createDialog.input.email.placeholder': 'メールアドレス',
  'staff.createDialog.input.tooSmall.errorMessage': '入力が必須の項目です。',
  'staff.createDialog.input.invalidString.errorMessage':
    'メールアドレスの形式で入力してください。',
  'staff.restoreDialog.title': '削除済みユーザーの復元',
  'staff.restoreDialog.message': 'ユーザー名 {name} を復元しますか？',
  'staff.restoreDialog.button.restore': '復元',
};
export default staffMessages;
